/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tag-cascader.vue?vue&type=template&id=78f3a68e&scoped=true&"
import script from "./tag-cascader.vue?vue&type=script&lang=ts&"
export * from "./tag-cascader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f3a68e",
  null
  
)

export default component.exports